import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
    this.awsS3Api = options.awsS3Api
  }
  async getUserProfile () {
    const { data } = await this.kulapApi.getUserProfile()
    this.store.dispatch('setUser', data)
    return data
  }
  async submitSuitTest (formData) {
    const { data } = await this.kulapApi.patchSubmitSuitTest(formData)
    return data
  }

  async getCountries () {
    const { data } = await this.awsS3Api.getCountries()
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/SuitabilityTest/service.js